import {QuestionCircleOutlined} from '@ant-design/icons';
import {BackendSupportCenter} from 'components/Backend/Support/Center';

export default BackendSupportCenter;

export const orderNum = 10;

export const icon = <QuestionCircleOutlined />;
